<template>
<div class="container--percentage" :style="{ height: height + 'px', borderRadius: borderRadius + 'px'}">
  <div class="container--percentage--block" :style="{ width: percentage + '%', height: height + 'px', borderRadius: borderRadius + 'px' }">
    <div class="container--percentage--block-anima" :style="{ height: height + 'px' }">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'metaPercentage',
  data () {
    return {
    }
  },
  props: {
    percentage: {
      type: String
    },
    borderRadius: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '10'
    }
  }
}
</script>

<style lang="scss" scoped>
.container--percentage {
    width: 100%;
    background: #D8D8D8;
    margin-bottom: 20px;
    height: 10px;
    overflow: hidden;
    border-radius: 20px;
    .container--percentage--block {
        overflow: hidden;
        .container--percentage--block-anima {
            background: #255F83;
            background: -webkit-gradient(linear, right top, left bottom, from(#276C8C), to(#0BA6B2));
            background: linear-gradient(top right, #276C8C, #0BA6B2);
            -webkit-animation-name: animaPercentage;
            animation-name: animaPercentage;
            -webkit-animation-duration: 0.5s;
            animation-duration: 0.5s;
            -webkit-animation-delay: 2s;
            animation-delay: 2s;
            height: 10px;
            -webkit-animation-fill-mode: backwards;
            animation-fill-mode: backwards;
            @-webkit-keyframes animaPercentage {
                from {
                    width: 0;
                }

                to {
                    width: 100%;
                }
            }
            @keyframes animaPercentage {
                from {
                    width: 0;
                }

                to {
                    width: 100%;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/metaPercentage/index.vue